
export default function authHeader() {
    // return authorization header with jwt token
    const jwt: string|null = localStorage.getItem('jwt');

    if (jwt) {
        return 'Bearer ' + jwt;
    } else {
        return null;
    }
}
